import apiClient from '../../../services/apiClient';
import { CategoryValues } from '../models/categories';

type DisciplesPathInquiryResponse = {
  status: string;
};

export const submitDisciplesPathInquiry = (categories: CategoryValues[]) => {
  const payload = {
    topics: categories,
  };
  return apiClient
    .post<DisciplesPathInquiryResponse>('/v1/marketing/disciples-path-inquiry', payload)
    .then(({ data }) => {
      return data;
    });
};
